import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
export default function AboutUs() {
  return (
    <section className="py-5 bg-dark text-light position-relative overflow-hidden">
      {/* Animated background glow */}
      <div className="aiw-bg-glow" aria-hidden="true" />

      <div className="container position-relative">
        <div className="row align-items-center g-5">
          {/* LEFT: AI visual */}
          <div className="col-12 col-lg-6">
            <div className="aiw-visual-wrap">
              <div className="aiw-orb" aria-hidden="true" />

              <div className="aiw-visual-card shadow-sm">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-cpu fs-4 text-info" aria-hidden="true" />
                    <span className="fw-semibold">AI Core</span>
                  </div>
                  <span className="badge bg-success">Live</span>
                </div>

                <p className="mb-0 text-light opacity-75">
                  Intelligent learning paths, smart recommendations, and real-world project
                  guidance—powered by modern AI workflows.
                </p>

                <div className="aiw-mini-stats mt-4">
                  <div className="aiw-mini-stat">
                    <div className="aiw-mini-stat__num">98%</div>
                    <div className="aiw-mini-stat__label">Learner satisfaction</div>
                  </div>
                  <div className="aiw-mini-stat">
                    <div className="aiw-mini-stat__num">24/7</div>
                    <div className="aiw-mini-stat__label">AI assistance</div>
                  </div>
                  <div className="aiw-mini-stat">
                    <div className="aiw-mini-stat__num">Real</div>
                    <div className="aiw-mini-stat__label">Project experience</div>
                  </div>
                </div>
              </div>

              {/* Floating icons */}
              <div className="aiw-float aiw-float-1" aria-hidden="true">
                <i className="bi bi-stars" />
              </div>
              <div className="aiw-float aiw-float-2" aria-hidden="true">
                <i className="bi bi-lightning-charge" />
              </div>
              <div className="aiw-float aiw-float-3" aria-hidden="true">
                <i className="bi bi-diagram-3" />
              </div>
            </div>
          </div>

          {/* RIGHT: About content */}
          <div className="col-12 col-lg-6">
            <div className="aiw-fade-up">
              <span className="badge aiw-badge mb-3">About Us</span>

              <h2 className="fw-bold display-6 mb-3">
                We build AI-powered learning experiences that feel human.
              </h2>

              <p className="text-light opacity-75 mb-4">
                AiW helps learners and teams grow through guided courses, hands-on projects,
                and intelligent support that adapts to your goals. We focus on clarity,
                speed, and real outcomes—so you can build confidence and ship better work.
              </p>

              <div className="row g-3 mb-4">
                <div className="col-12 col-md-6 aiw-fade-up aiw-delay-1">
                  <div className="aiw-feature">
                    <i className="bi bi-robot fs-4 text-info" aria-hidden="true" />
                    <div>
                      <div className="fw-semibold">Smart Guidance</div>
                      <div className="text-light opacity-75 small">
                        AI suggestions that support your next step.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 aiw-fade-up aiw-delay-2">
                  <div className="aiw-feature">
                    <i className="bi bi-shield-check fs-4 text-success" aria-hidden="true" />
                    <div>
                      <div className="fw-semibold">Secure by Design</div>
                      <div className="text-light opacity-75 small">
                        Best-practice patterns built into the platform.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 aiw-fade-up aiw-delay-3">
                  <div className="aiw-feature">
                    <i className="bi bi-graph-up fs-4 text-warning" aria-hidden="true" />
                    <div>
                      <div className="fw-semibold">Career Growth</div>
                      <div className="text-light opacity-75 small">
                        Job-ready skills with real portfolio outcomes.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 aiw-fade-up aiw-delay-4">
                  <div className="aiw-feature">
                    <i className="bi bi-code-slash fs-4 text-primary" aria-hidden="true" />
                    <div>
                      <div className="fw-semibold">Real Projects</div>
                      <div className="text-light opacity-75 small">
                        Learn by building, not just reading.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap gap-3">
                <Link to="/page/register" className="btn btn-primary btn-lg">
                  Join Now
                </Link>
                <HashLink to="/#events" className="btn btn-outline-light btn-lg">
                  Explore Courses
                </HashLink>
              </div>

              <p className="text-light opacity-50 small mt-3 mb-0">
                Tip: This section is CSS-animated and lightweight—great for performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
